import React, { useCallback, useContext } from 'react';
import styled from 'styled-components';
import Typography from 'kingpin/atoms/Typography';
import Icon from 'kingpin/atoms/Icon';
import FilterPlatesContext from 'contexts/FilterPlatesContext';

import { FILTER_PLATE_HEIGHT, FILTER_PLATE_MAX_WIDTH } from './Interactive';

const OuterDiv = styled.div`
  max-width: ${FILTER_PLATE_MAX_WIDTH}px;
  height: ${FILTER_PLATE_HEIGHT}px;
  cursor: default;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  border-radius: 8px;
  padding: 0px 8px;
  background-color: var(--color-badge-info-bg);
  gap: 4px;
`;

const CrossDiv = styled.div`
  display: flex;
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }
`;

const ExcludeTermedDriversPlate = ({
  plateId,
  isScope,
}: {
  plateId: string;
  isScope: boolean;
}) => {
  const { drillDowns, setDrillDowns, scope, setScope } =
    useContext(FilterPlatesContext);

  const onRemoved = useCallback(() => {
    if (isScope) {
      setScope(scope.filter((d) => d.id !== plateId));
    } else {
      setDrillDowns(drillDowns.filter((d) => d.id !== plateId));
    }
  }, [drillDowns, isScope, plateId, scope, setDrillDowns, setScope]);

  return (
    <OuterDiv data-testid="exclude-termed-drivers-plate">
      <CrossDiv onClick={onRemoved}>
        <Icon icon="cross" />
      </CrossDiv>
      <Typography.Body type="Button Text" isEllipsis>
        Exclude termed drivers
      </Typography.Body>
    </OuterDiv>
  );
};

export default ExcludeTermedDriversPlate;
